import { SET_NEWS_READ_TIMESTAMP } from '../actions/newsStatus'

const initialState = {
  newsReadTimestamp: 0
}

export default function setConnectionStatus(state = initialState, action) {
  switch (action.type) {
    case SET_NEWS_READ_TIMESTAMP:
      return {
        ...state,
        newsReadTimestamp: action.timestamp || Date.now()
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/newsStatus.js